module.exports = __webpack_public_path__ + "img/CustomerRegistration.c244870b.svg";